import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, Date, DateService, ISOFormat, Validation } from '@mews/framework';

export enum FiltersDateValueKey {
    date = 'date',
}

export const createDateSchema = (timezone: string, maxDateTime: Date, minDateTime?: Date) =>
    z.object({
        [FiltersDateValueKey.date]: Validation.Date.Iso.superRefine((value, ctx) => {
            const valueToDateTime = DateService.fromString(value, ISOFormat.Date, timezone);

            if (
                DateService.isGreater(valueToDateTime, maxDateTime) ||
                (minDateTime && DateService.isGreater(minDateTime, valueToDateTime))
            ) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    params: { errorType: CustomErrorType.DateString } satisfies CustomErrorParams,
                    fatal: true,
                });
                return z.NEVER;
            }
        }),
    });

export type LedgersDateValues = z.infer<ReturnType<typeof createDateSchema>>;
